<template>
     <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'municipal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Periódico Oficial</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <div class="card mt-4">
                        <div class="card-body pt-1">
                            <div class="row card-body">
                                <div class="container mb-3">
                                    <span class="subtitulo2"><p class="m-0">Seleccione el año a consultar</p></span>
                                </div>
                                <div class="col-7">
                                    <!-- AREA DEL SELECT -->
                                <select v-model="selected" class="custom-select custom-select-sm" style="height:40px;">
                                    <option disabled>Consultar año</option>
                                    <option
                                        v-for="(anio, index) in anio_select"
                                        :key="index"
                                        :value="anio"
                                    >
                                        {{anio}} 
                                    </option>
                                </select>

                                </div>
                                <div class="col-5">
                                    <button @click="consulta" class="btn btn-vino btn-block">Consultar</button>
                                </div>       
                            </div>
                        </div>
                    </div>

                    <h5 v-if="anioMostrar" class="subtitulo2 mt-5">Periodico Oficial año {{anioMostrar}}</h5>
                    <div v-show="!respuestaJson && anioMostrar">
                        <spiner></spiner>
                        <h6 class="text-center text-muted mb-5"> Cargando contenido...</h6>
                    </div>

                    <div class="accordion mt-4" id="accordionExample">
                        <!-- {{ i+1 }} -->
                        <div v-for="(item, i) in 12" :key="i">
                            <div v-if="consultaMes(i+1)" class="card">
                                <div class="card-header" :id="'headin'+i+1">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapse'+i+1" aria-expanded="true" :aria-controls="'collapse'+i+1" style="display:flex; justify-content:space-between;">
                                            <span class="mes-arcordeon"><p class="m-0">{{nombreMes(i+1)}}</p></span>
                                            <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                        </button>
                                    </h2>
                                </div>

                                <div :id="'collapse'+i+1" class="collapse" :aria-labelledby="'heading'+i+1" data-parent="#accordionExample">
                                    <div class="card-body">   
                                        <div  v-for="(datos, index) in respuestaJson" :key="index" >                                  
                                            <ul v-if="datos.Mes == i+1">
                                                <li> <a :href="urlServe + ruta + datos.Link_pdf" target="_Blank">{{datos.Descripcion}}</a> </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  

                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes sticky">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/leyIngresoMunicipal.jpg" alt="">  
                        </div>
                    </div>                   
                </div>
            </div>
        </div>
        <div class="text-aviso my-5">
            <h5> <span class="resaltado-vino">AVISO: </span> Puede ingresar al portal de la <u><a href="https://www.sgg.chiapas.gob.mx/periodico/periodico1218" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, para consultas más actualizadas.</h5>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import atrasComponent from './../../reload.vue'
    import spiner from './../../spiner.vue'
    import botonAtras from './../../button-atras'
    export default {
        mounted(){
            window.scrollTo(0, 0);
        },
        components:{
            atrasComponent,
            spiner,
            botonAtras
        },
        data: function(){
            return{
                selected: 'Consultar año',
                respuestaJson: null,
                JsonConsulta: this.$urlServiciosHacienda + 'PeriodicoOficial/ObtenerPeriodicoPorAño/', 
                collapse: false,
                anioMostrar: null,
                ruta: 'marco-juridico/Estatal/',
                anio_select: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004],
            }
        },
        methods:{
            consulta(){
                // console.log(this.selected); 
                if(this.selected > 1){
                    axios
                    .get(this.JsonConsulta + this.selected) 
                    .then((res) => this.respuestaJson= res.data.data )

                    this.anioMostrar = this.selected;
                }
            },
            rutaConsulta(urlServe, ruta, url){
                //rutaConsulta(urlServe, dato.ruta, dato.url)
                var respuesta;
                if(ruta == 0){
                    respuesta = urlServe + url;
                }else{
                    respuesta = url;
                }
                return respuesta;
            },



            /* --------------------------------------------------------------------------------------------------
                    AL ENTRAR A LA FUNCION, LLENA UNA VARIABLE CON EL MES QUE TRAE LA ITERACION DE LA RESPUESTA
                    PARAMETRO: VALOR, TRAE UN NUMERO (DEL 1 AL 12)

            */
            consultaMes(valor){
                if(this.respuestaJson){
                    var mes;  

                        $.each(this.respuestaJson, function (index, data) { 
                            if(data.Mes == valor){ 

                                     if(valor == 1)    mes = 'enero'; 
                                else if(valor == 2)    mes = 'febrero';
                                else if(valor == 3)    mes = 'marzo';
                                else if(valor == 4)    mes = 'abril';
                                else if(valor == 5)    mes = 'mayo';
                                else if(valor == 6)    mes = 'junio';
                                else if(valor == 7)    mes = 'julio';
                                else if(valor == 8)    mes = 'agosto';
                                else if(valor == 9)    mes = 'septiembre';
                                else if(valor == 10)   mes = 'octubre';
                                else if(valor == 11)   mes = 'noviembre';
                                else if(valor == 12)   mes = 'diciembre';
                                
                            }       
                        });

                        /*
                                LA 1RA ITERACION ES NECESARIA XQ A VECES LOS AÑOS NO TRAEN LOS 12 MESES.
                                ES NECESARIO QUE SE HAGAN LAS 2 ITERACIONES, NO PUEDO NETER EL RETURN EN LA 1RA PORQUE NO SEGUIRIA RECORRIENDO SI ES FALSE ANTES DE DICIEMBRE
                        
                                EN EL FOREACH ESTA ESTA CONDICION
                                 v-if="consultaMes(i+1)"
                                 POR ESO DEBE DAR V O F, PARA SABER SI ENTRA A PINTAR EL MES O NO
                        
                        */

                             if(valor == 1)  return (mes == 'enero')?      true : false;
                        else if(valor == 2)  return (mes == 'febrero')?    true : false;
                        else if(valor == 3)  return (mes == 'marzo')?      true : false;
                        else if(valor == 4)  return (mes == 'abril')?      true : false;
                        else if(valor == 5)  return (mes == 'mayo')?       true : false;    
                        else if(valor == 6)  return (mes == 'junio')?      true : false; 
                        else if(valor == 7)  return (mes == 'julio')?      true : false;
                        else if(valor == 8)  return (mes == 'agosto')?     true : false;
                        else if(valor == 9)  return (mes == 'septiembre')? true : false;
                        else if(valor == 10) return (mes == 'octubre')?    true : false;
                        else if(valor == 11) return (mes == 'noviembre')?  true : false;
                        else if(valor == 12) return (mes == 'diciembre')?  true : false;
                    }
                },





            /* --------------------------------------------------------------------------------------------------
                    ESTA FUNCION, RETORNA UNA CADENA DE TEXTO CON EL MES
                    PARAMETRO: MES, TRAE UN NUMERO (DEL 1 AL 12)

            */
            nombreMes(mes){
                     if(mes == '1')  return 'Enero'
                else if(mes == '2')  return 'Febrero' 
                else if(mes == '3')  return 'Marzo' 
                else if(mes == '4')  return 'Abril' 
                else if(mes == '5')  return 'Mayo' 
                else if(mes == '6')  return 'Junio' 
                else if(mes == '7')  return 'Julio' 
                else if(mes == '8')  return 'Agosto' 
                else if(mes == '9')  return 'Septiembre' 
                else if(mes == '10') return 'Octubre' 
                else if(mes == '11') return 'Noviembre' 
                else if(mes == '12') return 'Diciembre' 
            }
        },
        
    }
</script>
<style scoped>
.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }


.mes-arcordeon{ font-size: 1rem; }

li{ 
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .sticky{
        position: sticky !important;
        top: 8% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .tab-select{
        position: initial;
        z-index: auto;
    }
}

/* ---------------------------------- */
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width: 75% !important;
        background-color: #560F2C;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }
    .leyendaSeleccionar{
        font-size: 21px;
        font-weight: 300;
        margin-bottom: .5rem;
        /* margin-top: 1rem; */
    }

    /* ///ESTILOS PARA EL SELECT 2 */
    /* .selectMunicipios{
        margin-top: 2rem;
    } */
    .select2-container--default .select2-selection--single {  /****CHECAR PORQUE NO ME TOMA ESTOS ESTILOS EN EL SELECT 2******* */
   
        height: 3rem !important;
        padding-top: 8px;
        font-size: 23px;
    }

    #miCombo{
        width: 100%;
        height: 100%;
        border-radius: 5px;
        border: 1px solid #d9d4d4;
        font-size: 18px;
        color: #4e4a4a;
        padding: .5rem;
    }
    select:focus{ outline: none;}
    

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    /* .subtitulo2{ font-size: 1rem; } */

    .sec_imagen{ margin-top: 0rem; width: 66% !important;}
    .sec_imagen img { margin-right: 1.5rem;}

    a { font-size: 14px; }

    h6 { font-size: 13px; }

    .form-control-lg {  
        padding: .5rem .3rem;
        font-size: 0.9rem;
    }

    .btn{
        padding: .5rem .9rem;
        font-size: .7rem;
    }

    /* propiedades del card de consultar año */
    .card-body{ padding: .8rem; }
    .col-7{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .col-5{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }

    .subtitulo2{ font-size: 15px !important; }
    button{ font-size: .9rem !important; }
}

</style>